module.exports = __webpack_public_path__ + "static/img/upgrade.b70bc84b.png";